import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { getTOS } from "@r8er/lib/cms";
import classes from "@r8er/styles/Policy.module.css";
import type { InferGetStaticPropsType } from "next";
import Head from "next/head";

export async function getStaticProps() {
  const tos = await getTOS();

  return {
    props: {
      tos,
    },
  };
}
export default function Terms({
  tos,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <div>
      <Head>
        <title>Privacy &amp; Acceptable Use Policy - R8ER</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isSlim isTiny title="Terms of Service" img="/about-hero.png" />
        <h1 className={classes.title}>{tos.title}</h1>
        <div
          className={classes.container}
          dangerouslySetInnerHTML={{ __html: tos.html }}
        ></div>
      </Layout>
    </div>
  );
}
